import React from 'react';

/**
 * Закрытие модалки по Escape. Слушатель висит на document: onKeyDown на
 * оверлее не срабатывает, пока фокус не внутри него, а сразу после открытия
 * фокус остаётся на кнопке, которая модалку открыла.
 *
 * enabled = false — когда поверх открыто вложенное окно подтверждения: иначе
 * Escape закрыл бы обе модалки разом.
 */
export function useEscapeClose(onClose: () => void, enabled = true): void {
  const onCloseRef = React.useRef(onClose);
  onCloseRef.current = onClose;

  React.useEffect(() => {
    if (!enabled) return undefined;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCloseRef.current();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [enabled]);
}
